import { render, staticRenderFns } from "./BusBaseInfo.vue?vue&type=template&id=623f260a&scoped=true&"
import script from "./BusBaseInfo.vue?vue&type=script&lang=js&"
export * from "./BusBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusBaseInfo.vue?vue&type=style&index=0&id=623f260a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f260a",
  null
  
)

export default component.exports